import React, { useRef, useEffect } from "react";
function InstitutionPortalPage() {
  const portalRef = useRef(null);
  useEffect(() => window.DMAccess.mountPortal(portalRef.current), []);
  return <div ref={portalRef} />;
}
export { InstitutionPortalPage };
